import moment from 'moment';

export const getFormattedDate =
  (date) => date ? moment(date).format('MMM DD, YYYY') : '';
